<script setup>
import i18n from "@/i18n"
import Table from "./components/table"
// import { getProductTemplatePt } from "@/service";
import { onMounted, ref, watch, provide } from "vue"
import { useRouter, useRoute } from "vue-router";
import searchCom from "./components/search"
import collapseImg from "@/assets/images/products/collapse.svg"
import { getLangValue } from "@/utils/common"; //获取后端语言 
// import { getFileUrl } from "@/service"
const PageHeaderT = getLangValue("product-management", "title")
const router = useRouter()
const route = useRoute()
// const showCharts1 = ref({}) // search信息
const selectedInfo = ref('') // 选中的id
// provide('showCharts1', showCharts1) // 判断哪些图表可以展示
provide('selectedInfo', selectedInfo) //选中产品数据
const getMenuName = () => {
    let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
    let arr = data.filter(item => item.id === route.params.id)
    if (arr.length) {
        return `${i18n.global.locale == 'en' ? arr[0].name_en : arr[0].name}`
    }
    return route.params.id
}

// const checkMenuName = () => {
//     let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
//     let arr = data.filter(item => item.id === route.params.id)
//     if (arr.length) {
//         return true
//     }
//     return false
// }
const PageHeaderItems = ref([
    {
        text: getLangValue("product-management", "title"),
        active: false,
        // href: "#",
    },
    {
        text: `${getMenuName()}`,
        active: true,
        href: "#",
    },
    // {
    //     text: `${route.query.p_l_name? route.query.p_l_name: ''}`,
    //     active: true,
    // }
])
// const templateName = ref("")
const tableRef = ref(null)
// const publicTypeList = ref([])
// const chart_hot = ref(null)

// const current_tab = ref(0)
const showSearch = ref(true)
const searchRef = ref(null)
const tabList = ref([
    { name: getLangValue("product-management", "all"), number: 0, id: '', },
    { name: getLangValue("product-management", "notpublic"), number: 0, id: 1, },
    { name: getLangValue("product-management", "Opasc"), number: 0, id: 3, },
    { name: getLangValue("product-management", "completelypublic"), number: 0, id: 2, },
])

//methods

// const handlerToggleTab = (i, id) => {
//     current_tab.value = i
//     // 搜索数据 控制参数
//     tableRef.value.searchInfo.publicType = id;

// }
// const handleSearch = () => {
//     tableRef.value.searchInfo.templateName = templateName.value;
//     // 显示弹框则高级搜索
//     // if (!showSearch.value) {
//     //     tableRef.value.searchInfo.hscode = ""
//     //     tableRef.value.searchInfo.price = ""
//     //     tableRef.value.searchInfo.inventory = ""
//     //     tableRef.value.searchInfo.hand = []
//     //     tableRef.value.searchInfo.skin = []
//     //     tableRef.value.searchInfo.heat = []
//     // }else{
//     //     console.log(searchRef.value)
//     //     tableRef.value.searchInfo.hscode = searchRef.value.searchInfo.hscode
//     //     tableRef.value.searchInfo.price = searchRef.value.searchInfo.price
//     //     tableRef.value.searchInfo.inventory = searchRef.value.searchInfo.inventory
//     //     tableRef.value.searchInfo.hand = searchRef.value.searchInfo.hand
//     //     tableRef.value.searchInfo.skin = searchRef.value.searchInfo.skin
//     //     tableRef.value.searchInfo.heat = searchRef.value.searchInfo.heat

//     // }
// }
const addClick = () => {
    let url = router.resolve({
        name: 'products_detail',
        query: {
            tid: route.params.id,
            type: 'add',
            h_id: route.query.h_id,
            p_id: route.query.p_id,
            p_l_no: route.query.p_l_no,
            p_l_name: route.query.p_l_name,
            p_l_name_en: route.query.p_l_name_en,
            p_o_o: route.query.p_o_o,
            style: route.query.style,
            pattern: route.query.pattern,
            status: route.query.status,
            from: window.location.href, // 从哪里来的
        }
    })
    window.open(url.href, '_blank')
}

const search = (val) => {
    // 需要判断一下逻辑 不可能同时又2个为true
    // let arr = [searchRef.value.checkedHands, searchRef.value.checkedHeat, searchRef.value.checkedSkin, searchRef.value.checkedArt]
    // if (arr.filter(item => item).length > 1) {
    //     setTimeout(() => {
    //         tableRef.value.searchInfo.keyword = val.keyword
    //         tableRef.value.searchInfo.hscode = val.hscode
    //         tableRef.value.searchInfo.hscode_id = val.hscode_id
    //         tableRef.value.searchInfo.publicType = val.publicType
    //         tableRef.value.searchInfo.status = val.status
    //         tableRef.value.searchInfo.price = val.price
    //         tableRef.value.searchInfo.inventory = val.inventory
    //         tableRef.value.searchInfo.hand = searchRef.value.checkedHands ? val.hand : [] // 增加条件 需要勾选了才去查询
    //         tableRef.value.searchInfo.skin = searchRef.value.checkedSkin ? val.skin : [] // 增加条件 需要勾选了才去查询
    //         tableRef.value.searchInfo.heat = searchRef.value.checkedHeat ? val.heat : [] // 增加条件 需要勾选了才去查询
    //         tableRef.value.searchInfo.aesthetic_comfort = searchRef.value.checkedArt ? val.art : [] // 增加条件 需要勾选了才去查询
    //         tableRef.value.searchInfo.hand_feeling_layer = val.layer
    //     }, 1000)
    //     return
    // }
    tableRef.value.searchInfo.keyword = val.keyword
    tableRef.value.searchInfo.hscode = val.hscode
    tableRef.value.searchInfo.hscode_id = val.hscode_id
    console.log(val.publicType, route.query.pid)
    tableRef.value.searchInfo.publicType = val.publicType == 4 && route.query.p_id ? '' : val.publicType
    tableRef.value.searchInfo.status = val.status
    tableRef.value.searchInfo.price = [...val.price] //  浅拷贝
    tableRef.value.searchInfo.inventory = [...val.inventory] //  浅拷贝
    tableRef.value.searchInfo.hand = searchRef.value.checkedHands ? [...val.hand] : [] // 增加条件 需要勾选了才去查询
    tableRef.value.searchInfo.skin = searchRef.value.checkedSkin ? [...val.skin] : [] // 增加条件 需要勾选了才去查询
    tableRef.value.searchInfo.heat = searchRef.value.checkedHeat ? [...val.heat] : [] // 增加条件 需要勾选了才去查询
    tableRef.value.searchInfo.aesthetic_comfort = searchRef.value.checkedArt ? [...val.art] : [] // 增加条件 需要勾选了才去查询
    tableRef.value.searchInfo.hand_feeling_layer = val.layer
    tableRef.value.searchInfo.supplier = val.supplier
    // 如果是在公开数据库  只有选择了完全公开才传递雷达图数据
    if(!route.query.p_id) {
        tableRef.value.searchInfo.hand =  val.publicType==2?  tableRef.value.searchInfo.hand : []
        tableRef.value.searchInfo.skin =  val.publicType==2?  tableRef.value.searchInfo.skin : []
        tableRef.value.searchInfo.heat =  val.publicType==2?  tableRef.value.searchInfo.heat : []
        tableRef.value.searchInfo.aesthetic_comfort =  val.publicType==2?  tableRef.value.searchInfo.aesthetic_comfort : []
    }

}

const toogleSearch = () => {
    showSearch.value = !showSearch.value
}

// const getProductTemplatePtFun = async () => {
//     // 获取公开类型
//     const resp = await getProductTemplatePt()
//     if (resp) {
//         publicTypeList.value = resp.payload;
//         // console.log('数据库公开类型++', publicTypeList.value);
//     }
// }

const updateTabData = (data) => {
    // all_total: 0
    // data: []
    // private_total: 0
    // public_total: 0
    // supply_chain_public_total: 0
    tabList.value[0].number = data.all_total
    tabList.value[1].number = data.private_total
    tabList.value[2].number = data.supply_chain_public_total
    tabList.value[3].number = data.public_total
}



onMounted(() => {
    // getProductTemplatePtFun();
    if (route.query.p_l_name) {
        if (PageHeaderItems.value.length == 2) {
            PageHeaderItems.value.push(
                {
                    text: i18n.global.locale == 'en' ? `${route.query.p_l_name_en ? route.query.p_l_name_en : ''}` : `${route.query.p_l_name ? route.query.p_l_name : ''}`,
                    active: true,
                }
            )
        } else {
            PageHeaderItems.value[2].text = i18n.global.locale == 'en' ? route.query.p_l_name : route.query.p_l_name_en;
        }
        PageHeaderItems.value[1].href = ''
        PageHeaderItems.value[1].active = false
    } else {
        PageHeaderItems.value = [{
            text: getLangValue("product-management", "title"),
            active: false,
            // href: "#",
        },
        {
            text: `${getMenuName()}`,
            active: true,
            // href: "#",
        }
        ]
    }
})

// watch(templateName, () => {
//     handleSearch()
// })
watch(route, () => {
    // console.log(1);
    // PageHeaderItems.value[1].text = getMenuName()
    if (route.query.p_l_name) {
        if (PageHeaderItems.value.length == 2) {
            PageHeaderItems.value.push(
                {
                    text: i18n.global.locale == 'en' ? `${route.query.p_l_name_en ? route.query.p_l_name_en : ''}` : `${route.query.p_l_name ? route.query.p_l_name : ''}`,
                    active: true,
                }
            )
        } else {
            PageHeaderItems.value[2].text = i18n.global.locale == 'en' ? route.query.p_l_name : route.query.p_l_name_en;
        }
        PageHeaderItems.value[1].href = ''
        PageHeaderItems.value[1].active = false
    } else {
        PageHeaderItems.value = [{
            text: getLangValue("product-management", "title"),
            active: false,
            // href: "#",
        },
        {
            text: `${getMenuName()}`,
            active: true,
            // href: "#",
        }
        ]
    }
}, { deep: true })

// watch(showSearch, (val) => {
//     // search(searchRef.value.searchInfo)
//     if (val)
//         searchRef.value.initCharts()
// })

</script>
<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <!-- <div style="overflow-x: auto; overflow-y: hidden; height: calc(100vh - 140px);"> -->
        <div style="height: calc(100vh - 160px)" class="w-100">
            <div class="d-flex w-100 my-scroll-bar" style="height: 100%; position: relative; overflow-x: auto;">
                <div class="search bg-white card my-scroll-bar mb-0"
                    style="margin-right: 1.5rem;min-width:360px; max-width: 360px; height: 100%;" v-show="showSearch"
                    :title='getLangValue("product-management", "advanced_search")'>
                    <div class="w-100"
                        style="background-color: #E2E8ED; height: 40px; line-height: 40px; padding-left: 20px;font-size: 16px;">
                        {{ getLangValue("product-management", "advanced_search") }}</div>
                    <div style="height:calc(100% - 40px);">
                        <searchCom @search="search" ref="searchRef" :showSearch="showSearch" />
                    </div>

                </div>
                <!-- <div class="card" style="flex: 8;"> -->
                <div style="flex: 1;  height: 100%; flex-direction: column;" class="d-flex">
                    <div class="py-4 d-flex justify-content-between bg-white card-header border-0"
                        style="max-height: 85.5px;">
                        <div class="d-flex align-items-center">
                            <img :src="collapseImg" style="width: 30px;" class="mx-2 cursor-pointer" v-show="showSearch"
                                @click="toogleSearch">
                            <img :src="collapseImg" style="width: 30px; transform: rotateY(180deg);"
                                class="mx-2 cursor-pointer" v-show="!showSearch" @click="toogleSearch">
                            <span style="font-size: 16px;">{{ route.query.p_l_name ? i18n.global.locale == 'en' ?
                                route.query.p_l_name_en : route.query.p_l_name :
                                getMenuName() }}</span>
                        </div>
                        <div class="d-flex align-items-center">
                            <button v-permit="'my.product.add'" type="button" class="btn btn-success me-3"
                                v-if="route.query.p_id && route.query.h_id && route.query.status == 1"
                                @click="addClick()" style="min-width: 140px;">
                                <i class="ri-add-fill me-1 align-bottom"></i>
                                {{ getLangValue("product-management", "add") }}
                            </button>
                        </div>
                        <!-- <div class="w-10 mx-2" style="width: 200px;">
                            <input type="text" class="form-control" v-model="templateName"
                                :placeholder="i18n.global.t('products.searchPlaceholder')" />
                        </div> -->
                        <!-- <i title="高级搜索" v-show="showSearch" class="ri-arrow-left-circle-fill mx-2 cursor-pointer"
                            style="color: #878a99; font-size: 30px;position: absolute;right: 0;"
                            @click="toogleSearch"></i>
                        <i title="高级搜索" v-show="!showSearch" class="ri-arrow-right-circle-fill mx-2 cursor-pointer"
                            style="color: #878a99; font-size: 30px;" @click="toogleSearch"></i> -->
                    </div>
                    <!-- tab部分 -->
                    <!-- <ul class="nav nav-tabs nav-tabs-custom nav-success   px-2" role="tablist"
                        style="border-bottom: 1px solid #E9EBEC; padding: 0.3rem;">
                        <li class="nav-item" v-for="(tab, i) in tabList" :key="i">
                            <a :class="[
                                'nav-link',
                                'All',
                                'position-relative cursor',
                                i == current_tab && 'active',
                            ]" @click="handlerToggleTab(i, tab.id)"
                                style="color: #405189; font-weight: 600; font-size: 13px; display: inline;">
                                {{ tab.name }}
                                <span class="badge rounded-pill bg-primary-subtle "
                                    style="background-color: #F0654819; color: #F06548;">{{ tab.number }}</span>
                            </a>

                        </li>
                    </ul> -->
                    <!-- <div style="height: calc(100% - 90.8px);" class="bg-white"> -->
                    <div style="flex: 1; height: calc(100% - 85.5px) " class="bg-white card mb-0">
                        <Table ref="tableRef" @updateTabData="updateTabData" :showSearch="showSearch"
                            style="height: 100%;" />
                    </div>
                </div>

            </div>
        </div>
    </Layout>
</template>
<style scoped>
.nav-success.nav-tabs-custom .nav-link.active::after {
    background-color: #405189;
}

:deep(.el-select__placeholder.is-transparent) {
    font-size: 0.71094rem;
    color: #878a99 !important;
}

:deep(.el-select__selected-item.el-select__placeholder) {
    font-size: 0.71094rem;
    color: #212529;
}

:deep(.el-cascader .el-input__inner) {
    font-size: 0.71094rem;
    color: #212529;
}

:deep(.el-cascader .el-input__inner::placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-webkit-input-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-moz-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-moz-placeholder) {
    color: #878a99;
}

:deep(.el-cascader .el-input__inner::-ms-input-placeholder) {
    color: #878a99;
}
</style>
